module.exports = __webpack_public_path__ + "fonts/ralewayitalic.2466db0.ttf";